/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

import { AppState } from 'services/types';
import {
    makeSelectVirtualizedTableColumnHasFooterSummary,
    makeSelectVirtualizedTableColumnWidthAdjusted
} from 'services/virtualizedTable/selectors';
import { VirtualizedTableColumnKey } from 'services/virtualizedTable/types';

import VirtualizedTableFooterColumnSummary from '../VirtualizedTableFooterColumnSummary';
import { ROW_HEIGHT } from '../../constants';
import './styles.scss';

export interface OwnProps {
    columnKey: VirtualizedTableColumnKey;
}

export interface ConnectedProps {
    hasFooterSummary?: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableColumnHasFooterSummary>
    >;
    columnWidth?: ReturnType<
        ReturnType<typeof makeSelectVirtualizedTableColumnWidthAdjusted>
    >;
}

export type Props = OwnProps & ConnectedProps;

export const VirtualizedTableFooterColumnComponent = (
    props: Props
): React.ReactElement => {
    const { columnKey, hasFooterSummary, columnWidth } = props;

    return (
        <div
            style={{
                width: columnWidth,
                position: 'relative'
            }}
        >
            <div
                className="virtualized-table-footer-cell"
                style={{
                    height: ROW_HEIGHT
                }}
            >
                {hasFooterSummary && (
                    <VirtualizedTableFooterColumnSummary
                        columnKey={columnKey}
                    />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    hasFooterSummary: makeSelectVirtualizedTableColumnHasFooterSummary(),
    columnWidth: makeSelectVirtualizedTableColumnWidthAdjusted()
});

export default connect(mapStateToProps)(
    memo(VirtualizedTableFooterColumnComponent, isEqual)
);
